<template>
    <PersonalInfoPolicy20260720Content />
</template>

<script>
import PersonalInfoPolicy20260720Content from '@/views/policy/common/PersonalInfoPolicy20260720Content.vue';

export default {
    name: 'PrivacyPolicy20260720',
    components: {
        PersonalInfoPolicy20260720Content,
    },
};
</script>
